import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import handleError from 'utils/http/handleError';
import fetchAPI from 'utils/http/fetchAPI';
import { BACKEND_STATUS_LOADING, BACKEND_STATUS_LOADED, BACKEND_STATUS_ERROR } from 'redux/actionTypes/backendStatus';
import endUserMessages from 'utils/endUserMessages';
var loadBackendStatus = function loadBackendStatus(experimentId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var status, errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch({
              type: BACKEND_STATUS_LOADING,
              payload: {
                experimentId: experimentId
              }
            });
            _context.prev = 1;
            _context.next = 4;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/backendStatus"));
          case 4:
            status = _context.sent;
            dispatch({
              type: BACKEND_STATUS_LOADED,
              payload: {
                experimentId: experimentId,
                status: status
              }
            });
            return _context.abrupt("return", status);
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            errorMessage = handleError(_context.t0, endUserMessages.ERROR_FETCHING_BACKEND_STATUS);
            dispatch({
              type: BACKEND_STATUS_ERROR,
              payload: {
                experimentId: experimentId,
                error: errorMessage
              }
            });
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 9]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default loadBackendStatus;